import playerPermissions from "./player-permissions";
import collegePermissions from "./college-permissions";
import clubPermissions from "./club-permissions";

export const ROLES = [
  "player",
  "collegeHeadCoach",
  "clubHeadCoach",
  "premiumclubHeadCoach",
  "collegeNormalCoach",
  "collegeProfileMaintainer"
];

export const checkPermissionExistence = () => {
  // if (!localStorage["user-permissions"]) {
  //   window.location.href = "/";
  //   throw "You need to be logged in.";
  // }
};

export const userPermission = () => {
  return (
    localStorage["user-permissions"] &&
    JSON.parse(localStorage["user-permissions"])
  );
};

export default {
  ...playerPermissions,
  ...collegePermissions,
  ...clubPermissions
};
